import { OpenTabCartFragment } from '@/features/graphql/generated/graphql'
import AccountItemCard from '@/features/openTabs/components/AccountItemCard'
import { toDraftCartItemView } from '@/features/openTabs/utils/draftCart'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface DraftCartProps {
    items: OpenTabCartFragment['items']
    disabled?: boolean
    onEdit: (itemId: string) => void
    onRemove: (itemId: string) => void
    onChangeQuantity: (itemId: string, change: number) => void
}

const DraftCart: FC<DraftCartProps> = ({
    items,
    disabled = false,
    onEdit,
    onRemove,
    onChangeQuantity,
}) => {
    const { t } = useTranslation('app')

    return (
        <View style={styles.container} testID="open-account-draft-cart">
            {items.map((item) => (
                <AccountItemCard
                    key={item.uuid}
                    item={toDraftCartItemView(item, t)}
                    disabled={disabled}
                    onEdit={onEdit}
                    onRemove={onRemove}
                    onChangeQuantity={onChangeQuantity}
                    minimumQuantity={1}
                    testID={`open-account-draft-item-${item.uuid}`}
                />
            ))}
        </View>
    )
}

const styles = StyleSheet.create({
    container: { width: '100%', gap: 8 },
})

export default DraftCart
